import '../styles/PageGlobal.css';
import './AttributionPage.css';
import React from "react";
import { useParams } from "react-router-dom";


export default function AttributionPage() {
  const { attribution_id } = useParams();

  return (
    <div  className="containerMain">
  <h1>Attribution</h1>
  <p>Ceci est un contenu protégé</p>
<p style={{ color: "red" }}>
        DEBUG attribution_id: {attribution_id}
      </p>
  
</div>
  );
}